import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faEye } from "@fortawesome/free-solid-svg-icons";

// Formatea un valor de fecha para mostrar solo la parte de fecha (dd/MM/yyyy)
const formatDateOnly = (val) => {
  if (!val || val === "") return "";
  // Si viene en formato ISO (yyyy-MM-ddTHH:mm:ss), extraer solo la fecha
  if (typeof val === "string" && val.length >= 10 && val[4] === "-" && val[7] === "-") {
    const datePart = val.substring(0, 10);
    const [year, month, day] = datePart.split("-");
    return `${day}/${month}/${year}`;
  }
  // Intentar parsear
  const d = new Date(val);
  if (isNaN(d.getTime())) return val;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

export const ModuleTablaBasica = ({
  data = [],
  metadata = [],
  label,
  action,
}) => {
  const navigate = useNavigate();

  return (
    <S.Wrapper>
      {label && (
        <S.Header>
          <p>{label}</p>
        </S.Header>
      )}
      <S.Content>
        <table>
          <thead>
            <S.TrColumnTitles>
              {metadata.map((field) => (
                <th key={field.name} title={field.label}>
                  {field.label}
                </th>
              ))}
            </S.TrColumnTitles>
          </thead>
          <tbody>
            {data.map((register, index) => (
              <tr key={index}>
                {metadata.map((field) => {
                  if (field.type === "clickable") {
                    switch (field.name) {
                      case "email":
                        return (
                          <S.TdEmail key={field.name}>
                            <FontAwesomeIcon
                              icon={faEnvelope}
                              size="lg"
                              onClick={() => action(register.idCorreo)}
                            />
                          </S.TdEmail>
                        );

                      case "mirarCarga":
                        return (
                          <S.TdEye key={field.name}>
                            <FontAwesomeIcon
                              icon={faEye}
                              size="lg"
                              onClick={() =>
                                navigate(`/Carga/${register.idCarga}`)
                              }
                            />
                          </S.TdEye>
                        );

                      default:
                    }
                  }

                  const rawValue = register[field.name];
                  let cellValue;
                  if (field.type === "dateOnly") {
                    cellValue = formatDateOnly(rawValue);
                  } else if (field.type === "siNo") {
                    cellValue =
                      rawValue === true || rawValue === "1"
                        ? "Sí"
                        : rawValue === false || rawValue === "0"
                        ? "No"
                        : "";
                  } else if (field.type === "options") {
                    cellValue = field.options[rawValue] ?? rawValue;
                  } else {
                    cellValue = rawValue;
                  }

                  return (
                    <td key={field.name} title={cellValue}>
                      {cellValue}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </S.Content>
    </S.Wrapper>
  );
};

ModuleTablaBasica.propTypes = {
  data: PropTypes.array,
  metadata: PropTypes.array,
  label: PropTypes.string,
  action: PropTypes.func,
};
